class EditManager {
  id = 1
  componentsUnderEdit = []

  enterEditMode() {
    this.componentsUnderEdit.push({ id: this.id })
    return this.id++
  }

  exitEditMode(id) {
    this.componentsUnderEdit = this.componentsUnderEdit.filter(x => x.id !== id)
  }

  hasEdits() {
    return this.componentsUnderEdit.length > 0
  }
}

export default new EditManager()
